import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-down', 'ChevronDown', [["path",{"d":"M6 9l6 6l6 -6","key":"svg-0"}]]);